import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListaCampeonatos from './ListaCampeonatos';
import CriarCampeonato from './CriarCampeonato';
import CampeonatoDetalhe from './CampeonatoDetalhe';
import './Campeonatos.css';

function Campeonatos() {
  return (
    <Routes>
      <Route path="/" element={<ListaCampeonatos />} />
      <Route path="/novo" element={<CriarCampeonato />} />
      <Route path="/:id" element={<CampeonatoDetalhe />} />
    </Routes>
  );
}

export default Campeonatos;
